<template>
  <div class="page-content">
    <b-row>
      <b-col md="10">
        <page-breadcrumb title="Mission Rewards" class="mb-3" />
      </b-col>
    </b-row>
    <b-media>
      <section class="py-3">
        <div class="d-flex justify-content-between">
          <h2 class="mb-2">Mission Rewards</h2>
          <div>
            <loading-button
              class="ml-1"
              icon="PlusIcon"
              variant="primary"
              size="md"
              @click="openCreateMissionRewardModal"
            >
              Add
            </loading-button>
          </div>
        </div>
      </section>
    </b-media>
    <b-card>
      <mission-reward-table
        :mission_rewards="mission_rewards"
        @getList="getList"
        @changeMission="changeMission"
      />
    </b-card>
    <b-pagination
      class="mt-auto"
      pills
      size="lg"
      align="center"
      v-model="current_page"
      :total-rows="total_items"
      :per-page="items_per_page"
    />
    <mission-reward-form-modal ref="missionRewardFormModal" @loadData="getList" />
  </div>
</template>

<script>
import service from "../service";
import MissionRewardTable from "./_components/MissionRewardTable.vue";
import MissionRewardFormModal from "./_components/MissionRewardFormModal.vue";
import draggable from "vuedraggable";

export default {
  components: {
    MissionRewardTable,
    MissionRewardFormModal,
    draggable,
  },
  data() {
    return {
      current_page: 1,
      total_items: 0,
      items_per_page: 50,
      mission_rewards: [],
      editLanguage: null,
      is_mission_changed: false,
    };
  },

  watch: {
    mission_rewards(value, old_value) {
      if (!old_value.length) {
        return;
      }
      if (this.is_mission_changed === false) {
        this.is_mission_changed = true;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let response = await service.getList({
        page: this.current_page,
        limit: this.items_per_page,
      });
      if (response.data.type === "DATA") {
        this.mission_rewards = response.data.data.list;
        this.total_items = response.data.data.total;
      }
    },

    changeMission(value) {
      this.mission_rewards = value;
    },

    async updateDisplayOrder() {
      const res = await service.updateDisplayOrder({
        list: this.mission_rewards,
      });
      if (res.data && res.data.type === "SUCCESS") {
        await this.getList();
      }
    },

    goToCreateMissionReward() {
      this.$router.push({
        name: "mission-reward-create",
      });
    },

    openCreateMissionRewardModal() {
      this.$refs.missionRewardFormModal.openCreateModal();
    },
  },
};
</script>
